import type { GetApiCourses200ContentItemInstructor } from './getApiCourses200ContentItemInstructor';
import type { GetApiCourses200ContentItemLevel } from './getApiCourses200ContentItemLevel';
import type { GetApiCourses200ContentItemPrice } from './getApiCourses200ContentItemPrice';
import type { GetApiCourses200ContentItemSectionsItem } from './getApiCourses200ContentItemSectionsItem';

/**
 * 강의 정보 응답
 */
export type GetApiCourses200ContentItem = {
  /**
   * 평균 평점 (0.0-5.0)
   * @nullable
   */
  averageRating?: number | null;
  createdAt?: string;
  description?: string;
  /** 수강생 수 */
  enrollmentCount?: number;
  /** 강의 ID (초안 ID는 string일 수 있음) */
  id: string;
  /** 기본 사용자 정보 */
  instructor?: GetApiCourses200ContentItemInstructor;
  isPremium?: boolean;
  isPublished?: boolean;
  /** @nullable */
  level?: GetApiCourses200ContentItemLevel;
  price?: GetApiCourses200ContentItemPrice;
  /** 리뷰 수 */
  reviewCount?: number;
  /**
   * 강의 커리큘럼 섹션 목록 (상세 정보 포함)
   * @nullable
   */
  sections?: GetApiCourses200ContentItemSectionsItem[] | null;
  /** @nullable */
  thumbnailUrl?: string | null;
  title: string;
  updatedAt?: string;
};
